import { render, staticRenderFns } from "./device_s2.vue?vue&type=template&id=612ebe7b&scoped=true&"
import script from "./device_s2.vue?vue&type=script&lang=js&"
export * from "./device_s2.vue?vue&type=script&lang=js&"
import style0 from "./device_s2.vue?vue&type=style&index=0&id=612ebe7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612ebe7b",
  null
  
)

export default component.exports